// 用户中心-积分管理页面
import request from '@/utils/request'
import qs from 'qs'

// 获取积分列表
// 根据 params 对象的不同可进行条件查询
export const getAllPoints = (params) => {
  return request({
    url: '/api/points',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}

// 获取积分细明列表
export const getPointsDetail = (params) => {
  return request({
    url: '/api/pointsDetail',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}

// 充值
export const addPoints = (data) => {
  return request({
    url: 'api/points/add',
    method: 'PUT',
    data: data,
  })
}

// 导出积分列表
export const pointsExport = params => {
  return request({
    url: '/api/points/export',
    responseType: 'blob',
    method: 'GET',
    params: params,
  })
}